const ITEMS = [
  "Luxury Custom Homes",
  "Kitchen Remodeling",
  "Spa-Inspired Bathrooms",
  "Complete Renovations",
  "New Home Construction",
  "Interior Design",
  "Dallas — Fort Worth",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative py-10 border-y border-goldw/10 overflow-hidden select-none"
      aria-hidden="true"
    >
      <div className="flex w-max animate-marquee">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center shrink-0">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span
                  className={`font-serif text-3xl sm:text-5xl font-light px-8 whitespace-nowrap ${
                    i % 2 === 0 ? "text-ivory/90" : "text-outline italic"
                  }`}
                >
                  {item}
                </span>
                <span className="text-goldw/60 text-xl">·</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
